const Layout = () => import(/* webpackChunkName: "base_dependent" */ '../components/Layout.vue')
const Login = () => import(/* webpackChunkName: "login" */ '../views/User/Login.vue')
const merchantinfo = () => import(/* webpackChunkName: "merchantinfo" */ '../views/Merchant/merchantinfo.vue')
const hallinfo = () => import(/* webpackChunkName: "hallinfo" */ '../views/Merchant/hallinfo.vue')
const orderList = () => import(/* webpackChunkName: "orderList" */ '../views/Ordermanagement/orderList.vue')
const orderListdetail = () => import(/* webpackChunkName: "orderListdetail" */ '../views/Ordermanagement/orderListdetail.vue')
const settlementorder = () => import(/* webpackChunkName: "settlementorder" */ '../views/settlement/settlementorder.vue')
// const settlementorderdetail = () => import(/* webpackChunkName: "settlementorderdetail" */ '../views/settlement/settlementorderdetail.vue')

const settlementlist = () => import(/* webpackChunkName: "settlementorder" */ '../views/settlement/settlementlist.vue')
const settlementlistdetail = () => import(/* webpackChunkName: "settlementorder" */ '../views/settlement/settlementlistdetail.vue')
const traderinfo = () => import(/* webpackChunkName: "traderinfo" */ '../views/Merchant/traderinfo.vue')

// 商户订单/结算单
const merchantorderList = () => import(/* webpackChunkName: "merchantorderList" */ '../views/Ordermanagement/merchantorderList.vue')
const merchantsettlementlist = () => import(/* webpackChunkName: "merchantsettlementlist" */ '../views/settlement/merchantsettlementlist.vue')
const marchantorderListdetail = () => import(/* webpackChunkName: "marchantorderListdetail" */ '../views/Ordermanagement/marchantorderListdetail.vue')

// 更改密码
const updataPass = () => import(/* webpackChunkName: "login" */ '../views/User/updatapass.vue')

// 操盘手
const trader_tradermanage = () => import('../views/trader/tradermanage.vue')
const trader_merchantmanage = () => import('../views/trader/merchantmanage.vue')
const trader_hallmanage = () => import('../views/trader/hallmanage.vue')
const trader_ordermanage = () => import('../views/trader/ordermanage.vue')

const components = {
  Layout,
  Login,
  orderList,
  orderListdetail,
  settlementlist,
  settlementlistdetail,
  settlementorder,
  // settlementorderdetail,
  traderinfo,
  merchantinfo,
  hallinfo,
  merchantorderList,
  marchantorderListdetail,
  merchantsettlementlist,
  updataPass,
  trader_merchantmanage,
  trader_hallmanage,
  trader_ordermanage,
  trader_tradermanage
}
module.exports.default = module.exports = components;
